import { Forward } from "components/common/Icons";
import { HelpIcon2 } from "components/pages/detail/util";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import { TYPO } from "styles/Typo";
import { isNotKoreanMarketOpenTime } from "utils/api/price5min";
import { KOREA } from "utils/constant/ITME_INFO";
import { AdjClose, AdjCloseCHG } from "utils/detailAsset";
import { MONTH_ENG } from "utils/constant/ETC";
import moment from "moment-timezone";

function PriceForecast({
  detailData,
  riskTargetDate,
  CAT,
  LOC,
  isHoliday,
  setPriceForecastExplainModal,
}: {
  detailData: any;
  riskTargetDate: any;
  CAT: any;
  LOC: any;
  isHoliday: any;
  setPriceForecastExplainModal: any;
}) {
  const { t } = useTranslation("detail");
  const router = useRouter();

  const [isRealtime, setIsRealtime] = useState(false);

  useEffect(() => {
    if (!detailData) return;
    const checkIsRealtime = async () => {
      if (CAT === "Crypto") {
        setIsRealtime(true);
      } else if (CAT === "Stock") {
        if (LOC === KOREA) {
          if (isHoliday) {
            setIsRealtime(false);
          } else {
            const isNotKoreanMarketOpenTimeValue =
              await isNotKoreanMarketOpenTime();
            setIsRealtime(!isNotKoreanMarketOpenTimeValue);
          }
        } else {
          setIsRealtime(false);
        }
      } else {
        setIsRealtime(false);
      }
    };

    checkIsRealtime();
  }, [CAT, LOC, isHoliday]); // 필요한 의존성 추가

  const month = Number(riskTargetDate?.split("-")?.[1]) || null;
  const day = Number(riskTargetDate?.split("-")?.[2]) || null;
  const targetDate =
    month && day
      ? router.locale === "ko"
        ? `${month}월 ${day}일`
        : `${MONTH_ENG[month - 1]} ${day}`
      : "";

  const EXP_CVaRNTS_95 = Number(detailData?.EXP_CVaRNTS_95?.toFixed(1));
  const EXP_CVaRET_95 = Number(detailData?.EXP_CVaRET_95?.toFixed(1));
  const ADJ_CLOSE = detailData?.ADJ_CLOSE;
  const ADJ_CLOSE_CHG = detailData?.ADJ_CLOSE_CHG?.toLocaleString("en-us", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });

  const date =
    router.locale === "ko"
      ? moment(detailData?.BASE_DT).format("M월 D일")
      : moment(detailData?.BASE_DT).format("MMM D");

  // Recoil 로딩 게이트 제거 — detailData 는 GSSP fallback 으로 SSR 에서 이미 있음
  if (!detailData?.EXP_CVaRNTS_95) return <></>;

  return (
    <div className="bg-white px-6 pt-[30px] flex flex-col gap-1">
      <div className="flex flex-col gap-4">
        <p className={`${TYPO.TYPO4_SB} text-gray90`}>{t("volatilitySection")}</p>
        <div className="rounded-[14px] bg-white w-full flex flex-col border border-gray15">
          <div className="flex justify-between items-center px-4 py-[10px] ">
            <p className={`${TYPO.TYPO7_MD} text-gray60`}>
              {t("upsidePotential")}
            </p>
            <div className=" flex items-center  ">
              <p className={`${TYPO.TYPO7_1_MD} `}>
                <span className={`text-gray90`}>{t("max")}</span>{" "}
                <span className={`text-red50`}>
                  +{EXP_CVaRET_95.toFixed(1) + "%"}
                </span>
              </p>
            </div>
          </div>
          <div className="flex justify-between items-center px-4 py-[10px] border-t  border-gray15 ">
            <p className={`${TYPO.TYPO7_MD} text-gray60`}>
              {t("downsideRisk")}
            </p>
            <div className="  flex items-center justify-center  ">
              <p className={`${TYPO.TYPO7_1_MD} `}>
                <span className={`text-gray90`}>{t("max")}</span>{" "}
                <span className={`text-blue50`}>
                  -{EXP_CVaRNTS_95.toFixed(1) + "%"}
                </span>
              </p>
            </div>
          </div>
          {/* <div
            className="flex justify-between items-center px-4 py-[10px] border-t border-gray15 cursor-pointer"
            onClick={() => {
              window.dataLayer.push({
                event: "cDetailRisk",
              });
              router.push(`/detail/${detailData?.ITEM_CD_DL}/cvar`);
            }}
          >
            <p className={`${TYPO.TYPO7_MD} text-gray80`}>
              {t("currentPrice")}
            </p>
            <div className="flex items-center gap-1">
              <span className={`${TYPO.TYPO7_1_MD} text-gray80 shrink-0 `}>
                {AdjClose(detailData, router.locale, false)}
              </span>
              <span
                className={`${TYPO.TYPO7_1_MD} ${
                  Number(ADJ_CLOSE_CHG) > 0
                    ? "text-red50"
                    : Number(ADJ_CLOSE_CHG) < 0
                    ? "text-blue50"
                    : "text-gray50"
                } `}
              >
                {Number(ADJ_CLOSE_CHG) > 0 ? "+" : ""}
                {ADJ_CLOSE_CHG + "%"}
              </span>
              <Forward fill="gray40" width={16} height={16} />
            </div>
          </div> */}
        </div>
      </div>

      <div className="flex justify-end items-center">
        <p className={`${TYPO.TYPO8_RG} text-gray40`}>
          {t("lastUpdated", { date })}
        </p>
      </div>
    </div>
  );
}

const CurrentPrcieIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <circle
        cx="10"
        cy="10"
        r="5"
        stroke="var(--gray60)"
        strokeWidth="2"
        strokeDasharray="2 2"
      />
    </svg>
  );
};

const CurrentPriceLineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2"
      height="62"
      viewBox="0 0 2 62"
      fill="none"
    >
      <path
        d="M1 0L1 62"
        stroke="var(--gray60)"
        strokeWidth="2"
        strokeDasharray="2 2"
      />
    </svg>
  );
};

export default PriceForecast;
